module.exports = __webpack_public_path__ + "img/78.aa93c2a2.jpg";